import { gql } from 'graphql-request';
import { getGraphQLQueryClient } from './query-client';
import {
  Nullable,
  UserWithToken,
  WithData,
} from '@ygoargentina/sdk/api/api.types';

/**
 * El catálogo de formatos como lo devuelve el API.
 *
 * Vive en su propio módulo y no en `formats.ts` a propósito: ése es un archivo
 * de constantes puras que importan la super-app y la extensión, y meterle
 * `graphql-request` les entraría al bundle sin que lo usen.
 *
 * La división de responsabilidades entre los dos: el array de `formats.ts`
 * manda para lo que hay que dibujar teniendo sólo un id (color, ícono, label),
 * porque eso se resuelve sin red; la base manda para el `alias` y la lista
 * fija, que son lo único editable.
 */
export type GameFormatRow = {
  id: number;
  name: string;
  /** El otro nombre con el que se lo conoce. `null` = no tiene. */
  alias: Nullable<string>;
  slug: string;
  description: Nullable<string>;
  /**
   * La lista fija (los retro no rotan: Edison es siempre marzo 2010). `null` =
   * el formato rota y rige la global activa.
   */
  currentBanlistId: Nullable<number>;
};

const FORMAT_FIELDS = gql`
  fragment FormatFields on Format {
    id
    name
    alias
    slug
    description
    currentBanlistId
  }
`;

export const getGameFormats = async (user: Nullable<UserWithToken>) =>
  getGraphQLQueryClient(user).request<{ data: GameFormatRow[] }>(
    gql`
      ${FORMAT_FIELDS}
      query formats {
        data: formats {
          ...FormatFields
        }
      }
    `
  );

/**
 * Edita el formato. Sólo admin. Cada campo se toca sólo si viene: mandar la
 * lista fija no borra el alias.
 */
export const updateGameFormat = async (
  user: Nullable<UserWithToken>,
  id: number,
  input: { alias?: Nullable<string>; currentBanlistId?: Nullable<number> }
) =>
  getGraphQLQueryClient(user).request<WithData<GameFormatRow>>(
    gql`
      ${FORMAT_FIELDS}
      mutation updateFormat($id: Int!, $input: UpdateFormatInput!) {
        data: updateFormat(id: $id, input: $input) {
          ...FormatFields
        }
      }
    `,
    { id, input }
  );
